import * as index from '../node_modules/style-to-object/index.mjs.js';
import { getCjsExportFromNamespace } from './_commonjsHelpers.js';

var require$$0 = getCjsExportFromNamespace(index);

export { require$$0 as default };
